import { client } from "./index";

// Ownezzy's logos (/api/branding is public; changing them is Super Admin only)
export const getBranding = () => client.get("/branding");

export const uploadBranding = (kind, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return client.post(`/admin/branding/${kind}`, formData);
};

export const resetBranding = (kind) => client.delete(`/admin/branding/${kind}`);
